import React from "react";
const SvgCercaCasaInfo = props => (
  <svg fill="none" viewBox="0 0 16 16" {...props}>
    <g fill="#000">
      <path
        fillRule="evenodd"
        d="M1.333 8a6.667 6.667 0 1113.334 0A6.667 6.667 0 011.333 8zM8 2a6 6 0 100 12A6 6 0 008 2z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M8 7.5a.5.5 0 01.5.5v3.333a.5.5 0 01-1 0V8a.5.5 0 01.5-.5z"
        clipRule="evenodd"
      />
      <path d="M8.833 5.5a.833.833 0 11-1.666 0 .833.833 0 011.666 0z" />
    </g>
  </svg>
);
export default SvgCercaCasaInfo;
